<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === propertyAdminFilterKey.Type) {
      <mat-selection-list [formField]="formTree.type">
        @for (type of propertyTypeValues; track $index) {
          <mat-list-option [value]="type" (click)="$event.stopPropagation()">
            {{ type | etxeEnumDisplay: 'propertyType' }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === propertyAdminFilterKey.State) {
      <mat-selection-list [formField]="formTree.state">
        @for (state of stateValues; track $index) {
          <mat-list-option [value]="state" (click)="$event.stopPropagation()">
            {{ state | stateStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === propertyAdminFilterKey.Location) {
      <mat-selection-list [formField]="formTree.location">
        @for (region of frenchAddressRegionValues; track $index) {
          <mat-list-option [value]="region" (click)="$event.stopPropagation()">
            {{ region }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (
      currentFilterView() === filter.label && filter.column === propertyAdminFilterKey.VerificationOwner
    ) {
      <mat-selection-list [formField]="formTree.verificationOwner">
        @for (status of propertyVerificationStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | etxeEnumDisplay: 'verificationStatus' }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (
      currentFilterView() === filter.label && filter.column === propertyAdminFilterKey.DocumentStatus
    ) {
      <mat-selection-list [formField]="formTree.documentStatus">
        @for (status of propertyDocumentStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | etxeEnumDisplay: 'documentStatus' }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (
      currentFilterView() === filter.label && filter.column === propertyAdminFilterKey.ModerationFlag
    ) {
      <mat-selection-list [formField]="formTree.moderationFlag">
        <mat-list-option value="true" (click)="$event.stopPropagation()"> Avec signalement </mat-list-option>
        <mat-list-option value="false" (click)="$event.stopPropagation()"> Sans signalement </mat-list-option>
      </mat-selection-list>
    }
  }
</form>
